import { render, staticRenderFns } from "./web-audiencead-add.vue?vue&type=template&id=05a1bc6c&scoped=true&"
import script from "./web-audiencead-add.vue?vue&type=script&lang=js&"
export * from "./web-audiencead-add.vue?vue&type=script&lang=js&"
import style0 from "./web-audiencead-add.vue?vue&type=style&index=0&id=05a1bc6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a1bc6c",
  null
  
)

export default component.exports